import { menuItems as adminMenuItems } from '../../../modules/admin/menu';
import { toNavSections } from '../../utils/subNav.utils';

export const useAdminSubNav = () => toNavSections(adminMenuItems);
